import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const a = "connection";
class r extends n {
  /**
   * Authenticates a user and returns connection data.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/connection/login`
   *
   * @param {LoginData | LoginWithTokenData} loginData - The user's login credentials or token.
   * @param {LoginHeaders} [headers={}] - Optional headers for the request.
   * @returns {Promise<ConnectionReceivedData>} A promise resolving to the received connection data.
   */
  login = async (t, s = {}) => {
    const { data: o } = await this.post(
      `${a}/login`,
      t,
      s
    );
    return o;
  };
  /**
   * Generates a connection token for a user.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/connection/generate_token`
   *
   * @param {string} userId - The ID of the user.
   * @param {number} ttl - Time-to-live (in seconds) for the generated token.
   * @returns {Promise<V2ConnectionToken>} A promise resolving to the generated token.
   */
  generateConnectionToken = async (t, s) => {
    const { data: o } = await this.post(`${a}/generate_token`, {
      ttl: s,
      user_id: t
    });
    return o;
  };
  /**
   * Completes an invitation with password data.
   *
   * HTTP Verb: POST
   * Endpoint URL: /connection/invitation
   *
   * @param {PasswordData} invitData
   * @returns {Promise<ConnectionReceivedData>}
   */
  completeInvitation = async (t) => {
    const { data: s } = await this.post(
      `${a}/invitation`,
      t
    );
    return s;
  };
  /**
   * Logs out the current user.
   *
   * HTTP Verb: POST
   * Endpoint URL: /connection/logout
   *
   * @returns {Promise<ConnectionLogoutData>}
   */
  logout = async () => {
    const { data: t } = await this.post(`${a}/logout`);
    return t;
  };
  /**
   * Resets the password using provided data.
   *
   * HTTP Verb: POST
   * Endpoint URL: /connection/reset_password
   *
   * @param {PasswordData} resetData
   * @returns {Promise<StatusType>}
   */
  resetPassword = async (t) => {
    const { data: s } = await this.post(`${a}/reset_password`, t);
    return s;
  };
  /**
   * Sends lost password instructions to email.
   *
   * HTTP Verb: POST
   * Endpoint URL: /connection/lost_password
   *
   * @param {LostPasswordData} lostData
   * @returns {Promise<ConnectionReceivedData>}
   */
  lostPassword = async (t) => {
    const { data: s } = await this.post(
      `${a}/lost_password`,
      t
    );
    return s;
  };
  /**
   * Handles OIDC authentication via alias.
   *
   * HTTP Verb: POST
   * Endpoint URL: /oidc/{ssoAlias}/auth
   *
   * @param {string} ssoAlias
   * @param {LoginSsoOidcData} loginData
   * @returns {Promise<ConnectionReceivedData>}
   */
  oidcAuth = async (t, s) => {
    const { data: o } = await this.post(
      `oidc/${t}/auth`,
      s
    );
    return o;
  };
  /**
   * Generates a login URL for SSO based on type and alias.
   *
   * @param {string} type
   * @param {string} ssoAlias
   * @returns {string}
   */
  generateSsoLoginUrl = (t, s) => `/api/v2/${t}/${s}/login`;
}
export {
  r as Connection,
  a as RESOURCE_URI
};
